import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';
import { AlertService } from '../service/alert.service';
import { HTTP_CONTEXT } from '../class/app-constant';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private alertService: AlertService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        // Handle JSON error returned as Blob
        if (
          error.error instanceof Blob &&
          error.error.type?.includes('application/json')
        ) {
          return from(error.error.text()).pipe(
            mergeMap((text: any) => {
              let body: any = {};

              try {
                body = JSON.parse(text);
              } catch {
                body = { message: text };
              }

              this.handleError(error.status, body.message);

              return throwError(() => body);
            }),
          );
        }

        const msg =
          error?.error?.message ||
          error?.message ||
          error?.result ||
          'An error occurred';

        this.handleError(error.status, msg);

        return throwError(() => error);
      }),
    );
  }

  private handleError(status: number, msg: string) {
    switch (status) {
      case 401:
        this.alertService.showToast(
          'Token expired, Please login again.',
          'warn',
        );
        this.authenticationService.logout();
        break;

      case 400:
      case 405:
      case 500:
        this.alertService.showToast(msg, 'warn');
        break;

      default:
        this.alertService.showToast(msg, 'warn');
    }
  }
}

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
  constructor(private alertService: AlertService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const skipSuccess = req.context.get(HTTP_CONTEXT.SKIP_SUCCESS);
    return next.handle(req).pipe(
      tap((event) => {
        if (
          event instanceof HttpResponse &&
          (req.method === 'POST' ||
            req.method === 'DELETE' ||
            req.method === 'PUT')
        ) {
          // if (event.body instanceof Blob) {
          //     // Optional: you may want to check the req.url or headers for "download" endpoints
          //     const fileName = this.getFileNameFromHeaders(event.headers) || 'downloaded-file';
          //     this.downloadHelper.downloadFile(event.body, fileName);
          //     return;
          //   }
          // Handle the success response here
          if (event.status == 200 && !skipSuccess) {
            if (event.body?.message) {
              this.alertService.showToast(event?.body.message, 'success');
            }
          }
          console.log(`${req.method} Success Response:`, event);
        }
      }),
    );
  }
}
